import React from 'react';
import styled from 'styled-components';

import { ContentSet } from 'components/Shared/Scaffolding';
import Tab from 'components/Shared/Tabs/Tab';
import TabContent from 'components/Shared/Tabs/TabContent';
import { SCAFFOLDING, TABS } from 'theme';

const StyledTabs = styled.div`
    margin: -${TABS.PADDING.Y} -${TABS.PADDING.X};
`;

const TabContentWrapper = styled.div`
    position: relative;
`;

const TabGroup = ({ tabs, selected = 0, onTabClick = () => {}, ...props }) => {
    return (
        <ContentSet spacing={SCAFFOLDING.GUTTER}>
            <StyledTabs>
                {tabs.map((tab, index) => {
                    return (
                        <Tab active={selected === index} key={index} onClick={() => onTabClick(tab, index)}>
                            {tab}
                        </Tab>
                    );
                })}
            </StyledTabs>
            <TabContentWrapper>
                {props.children.map((Child, index) => {
                    return (
                        <TabContent isOpen={selected === index} key={index}>
                            {Child}
                        </TabContent>
                    );
                })}
            </TabContentWrapper>
        </ContentSet>
    );
};

export default TabGroup;
